import { lazy } from 'react';

export const AsyncMainPageContainer = lazy(() => import(
  /* webpackChunkName: 'main_page' */
  './MainPageContainer'
));
